import ApiUtil from './api';

class Api extends ApiUtil {

  getQuestState() {
    return this.get('/gamification/state');
  }

}

export default new Api();
